import bannerImg from "../../assets/img/banner.png"
import bannerCroppedImg from "../../assets/img/banner-cropped.png"
import { useMediaQuery } from 'react-responsive'

import "./Banner.css"
import React from "react";

const Banner: React.FC = () => {
  const isNarrowScreen = useMediaQuery({ query: '(max-width: 768px)' })

  return (
      <section className="banner" id="home">
        <img
            src={isNarrowScreen ? bannerCroppedImg : bannerImg}
            alt="Banner">
        </img>
      </section>
  );
}

export default Banner;
